module.exports = __webpack_public_path__ + "img/bn25.b441c5ac.png";